// Canonical race/ethnicity options used across:
//   • Bus screening wizard (StepDemographics)
//   • Patient/Member edit (PatientInfoTab)
//   • Analytics reports cohort filters
//
// IMPORTANT: `value` strings are persisted in `Patient.raceEthnicity` and
// `Patient.raceEthnicitySubgroup`. They MUST stay in sync with
// `BHA-backend/models/HealthData.js` and any analytics breakdown mappings.

export const RACE_OPTIONS = [
  { value: 'blackOrAfricanAmerican',     label: 'Black or African American' },
  { value: 'hispanicOrLatino',           label: 'Hispanic or Latino' },
  { value: 'americanIndianOrAlaskaNative', label: 'American Indian or Alaska Native' },
  { value: 'asianOrAsianAmerican',       label: 'Asian or Asian American' },
  { value: 'middleEasternOrNorthAfrican', label: 'Middle Eastern or North African' },
  { value: 'nativeHawaiianOrOPI',        label: 'Native Hawaiian or Other Pacific Islander' },
  { value: 'white',                      label: 'White' },
  { value: 'other',                      label: 'Other' },
];

// Sub-group options keyed by top-level race value. Top-levels with no
// entry (or empty array) hide the second dropdown entirely so the form
// stays light by default.
export const RACE_SUBGROUPS = {
  blackOrAfricanAmerican: [
    { value: 'blackAmerican', label: 'Black American' },
    { value: 'african',       label: 'African' },
    { value: 'caribbean',     label: 'Caribbean' },
    { value: 'other',         label: 'Other' },
  ],
  hispanicOrLatino: [
    { value: 'mexicanOrMexicanAmerican', label: 'Mexican or Mexican American' },
    { value: 'puertoRican',              label: 'Puerto Rican' },
    { value: 'cuban',                    label: 'Cuban' },
    { value: 'dominican',                label: 'Dominican' },
  ],
  asianOrAsianAmerican: [
    { value: 'chinese',    label: 'Chinese' },
    { value: 'indian',     label: 'Indian' },
    { value: 'filipino',   label: 'Filipino' },
    { value: 'vietnamese', label: 'Vietnamese' },
    { value: 'korean',     label: 'Korean' },
    { value: 'japanese',   label: 'Japanese' },
  ],
  middleEasternOrNorthAfrican: [
    { value: 'lebanese', label: 'Lebanese' },
    { value: 'iranian',  label: 'Iranian' },
    { value: 'egyptian', label: 'Egyptian' },
    { value: 'syrian',   label: 'Syrian' },
    { value: 'moroccan', label: 'Moroccan' },
  ],
  nativeHawaiianOrOPI: [
    { value: 'nativeHawaiian', label: 'Native Hawaiian' },
    { value: 'samoan',         label: 'Samoan' },
    { value: 'chamorro',       label: 'Chamorro' },
    { value: 'tongan',         label: 'Tongan' },
  ],
};

export const hasRaceSubgroups = (race) =>
  Array.isArray(RACE_SUBGROUPS[race]) && RACE_SUBGROUPS[race].length > 0;

export const raceLabel = (val) =>
  RACE_OPTIONS.find((o) => o.value === val)?.label || val;

export const raceSubgroupLabel = (race, subVal) => {
  const list = RACE_SUBGROUPS[race] || [];
  return list.find((o) => o.value === subVal)?.label || subVal;
};
